import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: center;
`;
export const TitleTextStyled = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  line-height: normal;
  word-break: break-word;
  margin: 0;
`;
export const StyledCounter = styled.p`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
`;
